import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/')({
  component: () => {
    return <Outlet />
  },
})
